import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faTrash, faUserSlash } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { useStableCallback } from '@components-shared/src/hooks/useStableCallback';
import { AdminDeletePostModal, DeletePostModal } from '@components/Feed/Post/DeletePostModal';
import { DropdownMenuItem } from '@components/basics/Dropdowns/GlobalDropdown';
import { useAuth } from '@context/auth/base';
import { ModalType, useModal } from '@context/modal';

export function PostDropdown({ postId, creatorUserId }: { postId: string; creatorUserId: string }) {
  const { openModal } = useModal();
  const { authUser } = useAuth();

  const handleDeleteClicked = useStableCallback(() => {
    openModal(ModalType.DELETE_POST_CONFIRMATION, {
      body: <DeletePostModal postId={postId} />,
    });
  });

  const handleAdminDeleteClicked = useStableCallback(() => {
    openModal(ModalType.DELETE_POST_CONFIRMATION, {
      body: <AdminDeletePostModal postId={postId} />,
    });
  });

  const handleAdminBlockUserClicked = useStableCallback(() => {
    window.open(`${window.location.origin}/admin/moderate/${creatorUserId}`, '_blank');
  });

  return (
    <>
      {creatorUserId === authUser?.id && (
        <DropdownMenuItem onClick={handleDeleteClicked}>
          <div className="flex items-center gap-3 font-base text-base-m font-medium text-destructive700">
            <FontAwesomeIcon icon={faTrash} size="lg" />
            Delete
          </div>
        </DropdownMenuItem>
      )}
      {authUser?.roles?.isAdmin && (
        <>
          {creatorUserId !== authUser?.id && (
            <DropdownMenuItem onClick={handleAdminDeleteClicked}>
              <div className="flex items-center gap-3 font-base text-base-m font-medium text-destructive700">
                <FontAwesomeIcon icon={faTrash} size="lg" />
                Delete (Admin)
              </div>
            </DropdownMenuItem>
          )}
          <DropdownMenuItem onClick={handleAdminBlockUserClicked}>
            <div className="flex items-center gap-3 font-base text-base-m font-medium text-destructive700">
              <FontAwesomeIcon icon={faUserSlash} size="lg" />
              Block User (Admin)
            </div>
          </DropdownMenuItem>
        </>
      )}
    </>
  );
}
